import '../styles.scss';
import { Label } from 'semantic-ui-react';
import Link from '~/components/Link';
import { useRequiredResponseCountsQuery } from '~/requests/projects/useRequiredResponseCounts';
import { Portfolio } from '~/types/portfolio';
import { DealSummaryInvestorData } from '~/types/portfolio/PortfolioDealSummary';

interface MessagesProps {
  portfolio: Portfolio;
  investor: DealSummaryInvestorData;
  awaitingBid?: boolean;
}

const Messages = ({ 
  portfolio, 
  investor, 
  awaitingBid 
}: MessagesProps) => {
  const { data: requiredResponseCountsData } = useRequiredResponseCountsQuery();
  const requiredResponseCount = requiredResponseCountsData
    ?.filter((data: any) => data.investorId === investor.id)
    ?.reduce((acc: number, data: any) => acc + data.count, 0)
    ?? 0;

  return (
    <div>
      <Link 
        to={`/portfolio/${portfolio?.id}/messages?investorId=${investor?.id}`} 
        noUnderline
        color={awaitingBid ? 'var(--color-pure-white)' : 'default'}
      >
        View messages
      </Link>
      {requiredResponseCount ? (
        <Label circular color='red'>
          {requiredResponseCount} 
        </Label>
      ) : null}
    </div>
  );
};

export default Messages;